import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface FinancialEntityNamesParams extends DefaultHttpHeaders {
  /** Name of the bank entity to be filtered. At least 3 characteres will be required */
  financialEntityName: string;
}

@Injectable()
export class FinancialEntityNamesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining financial entities
   * Service for obtaining financial entities
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundFinancialEntityNames
   */
  financialEntityNames(params: FinancialEntityNamesParams): Observable<ParameterResult[]> {
    const queryParams = {
      financialEntityName: params.financialEntityName,
    };

    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/financialEntityNames',
      queryParams,
    });
  }
}
